import { db } from '../../config/firebaseconfig'
import forOwn from 'mout/object/forOwn'

export default function fetchAllStudentScoring(students) {
  return new Promise((resolve, reject) => {
    let promisesUA = [], promisesUser = [], studentList = [], studentScoring = {}, users = {}
    forOwn(students, (val, key) => {
      if (val) {
        studentList.push(key)
      }
    })
    studentList.forEach((student) => {
      const promiseUA = db.collection('userAssessments').where('userId', '==', student).get()
      promisesUA.push(promiseUA)
      const promiseUser = db.collection('students').doc(student).get()
      promisesUser.push(promiseUser)
    })
    Promise.all(promisesUA)
      .then((results) => {
        results.forEach((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (doc.exists) {
              const uA = doc.data()
              studentScoring[uA.userId] = {
                activity: uA.activity,
                answers: uA.answers,
                answersByItem: uA.answersByItem,
                scoring: uA.scoring,
                userAssessmentId: uA.userAssessmentId,
                userId: uA.userId,
              }
            }
          })
        })
        return Promise.all(promisesUser)
      })
      .then((results) => {
        results.forEach((doc) => {
          if (doc.exists) {
            const user = doc.data()
            studentScoring[user.id].firstName = user.firstName
            studentScoring[user.id].lastName = user.lastName
            studentScoring[user.id].fullName = user.fullName
          }
        })
        resolve(studentScoring)
      })
      .catch(err => reject(err))
  })
}



// WEBPACK FOOTER //
// ./src/helpers/assessment/fetchAllStudentScoring.js